import { defineRecipe } from '@chakra-ui/react';

export default defineRecipe({
  base: {
    textDecoration: 'underline',
  },
  variants: {
    variant: {
      plain: {
        color: 'primary.500',
      },
      underline: {
        color: 'primary.500',
      },
    },
  },
});
